import { lazy } from 'react';

const KnowRoutes = [
    {
        label: '知识图谱',
        key: 'knowledge-graph',
        show: true,
        path: '/knowledgeGraph',
        element: lazy(() => import('src/components/Layout/PlayerLayout')),
        children: [
            {
                label: '知识图谱',
                key: 'knowledge-graph',
                show: false,
                path: '/knowledgeGraph',
                element: lazy(() => import('@/page/fullScreenKnowGraph')),
                needJudgeRealName: true,
                realNameType: 'knowledge-graph'
            }
        ]
    }
];

export default KnowRoutes;
